export const pinSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}
export const pinSizeApiValues = {
  [pinSizeOptions.SMALL]: 'SMALL',
  [pinSizeOptions.MEDIUM]: 'MEDIUM',
  [pinSizeOptions.LARGE]: 'BIG'
}
